import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { ButtonVariant } from '@/components/ui/button/button.types';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { Link } from '@/components/ui/link/link.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface FaqUnitButtonProps {
  label?: string;
  variant?: ButtonVariant;
  className?: string;
  showIcon?: boolean;
}

export const FaqUnitButton = ({
  label = 'Encontrar uma unidade física',
  variant = 'secondary',
  className,
  showIcon = true,
}: FaqUnitButtonProps) => {
  const { buttonSmFit } = styleFaq();

  return (
    <Button
      asChild
      startIcon={showIcon ? faLocationDot : undefined}
      startIconSize="sm"
      variant={variant}
      className={className ?? buttonSmFit()}
    >
      <Link
        prefetch={false}
        data-testid={DataTestIdEnum.FAQ_FIND_BRANCH_BUTTON}
        href="/unidades-perto-de-voce/"
        data-analytics-event={AnalyticsEnum.CLICK_FAQ_SEARCH_BRANCHES_BUTTON}
      >
        {label}
      </Link>
    </Button>
  );
};
